/**
 * 将json格式字符串转为对象
 *
 * @export
 * @param {String} str
 * @returns
 */
export function strToJson(str) {
  if (!str || getJsBasicType(str) !== 'String') return
  let json = {}
  try {
    json = JSON.parse(str)
  } catch (e) {
    try {
      // eslint-disable-next-line
      json = eval('(' + str + ')')
    } catch (e) {
      json = null
    }
  }
  return json
}

/**
 * 将日期对象转为特定格式的日期字符串
 *
 * @export
 * @param {String} fmt 日期格式比如 "yyyy-MM-dd hh-mm-ss"
 * @param {Date} date
 * @returns str
 */
export function dateFormat(fmt, date) {
  let thisDate = date || new Date()
  var o = {
    'M+': thisDate.getMonth() + 1, // 月份
    'd+': thisDate.getDate(), // 日
    'h+': thisDate.getHours(), // 小时
    'm+': thisDate.getMinutes(), // 分
    's+': thisDate.getSeconds(), // 秒
    'q+': Math.floor((thisDate.getMonth() + 3) / 3), // 季度
    s: thisDate.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (thisDate.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return fmt
}

/**
 * 将字符串日期转换为特定格式的日期
 *
 * @export
 * @param {String} fmt 日期格式比如 "yyyy-MM-dd hh-mm-ss"
 * @param {String} dateString 需要格式化的字符串 "2018-01-01 00:00:00"
 * @returns
 */
export function stringDateFormat(fmt, dateString) {
  return dateFormat(
    fmt,
    new Date(dateString.replace(/\.0$/, '').replace(/-/g, '/'))
  )
}

/**
 * js类型
 *
 * @export
 * @param {any} val
 * @returns
 */
export function judgmentType(val) {
  return Object.prototype.toString.call(val)
}

/**
 * js的数据类型
 *
 * @param {any} val
 * @returns
 */
export function getJsBasicType(val) {
  if (judgmentType(val) === '[object Object]') {
    return 'Object'
  }
  if (judgmentType(val) === '[object Array]') {
    return 'Array'
  }
  if (judgmentType(val) === '[object Null]') {
    return 'null'
  }
  if (judgmentType(val) === '[object String]') {
    return 'String'
  }
  if (judgmentType(val) === '[object Number]') {
    return 'Number'
  }
  if (judgmentType(val) === '[object Undefined]') {
    return 'Undefined'
  }
  if (judgmentType(val) === '[object Boolean]') {
    return 'Boolean'
  }
}

/**
 * 将数字转为逗号分开的科学计数
 *
 * @export
 * @param {Number} val
 * @returns
 */
export function toThousands(val) {
  return (val || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
}

export function diffReqData(oldArr, sourcesObj) {
  let obj = {}
  const arr = []
  oldArr.forEach(item => {
    obj[item.parameter] = item
  })
  for (let [key, value] of Object.entries(sourcesObj)) {
    if (key in obj) {
      arr.push({
        parameter: key,
        isNeed: 'true',
        value: value,
        type: getJsBasicType(value),
        desc: obj[key].desc,
        exampleVlaue: value
      })
    } else {
      arr.push({
        parameter: key,
        isNeed: 'true',
        value: value,
        type: getJsBasicType(value),
        desc: '',
        exampleVlaue: value
      })
    }
  }
  obj = null
  return arr
}

export function diffResData(oldArr, sourcesObj) {
  let obj = {}
  const arr = []
  oldArr.forEach(item => {
    obj[item.parameter] = item
  })
  for (let [key, value] of Object.entries(sourcesObj)) {
    if (key in obj) {
      arr.push({
        parameter: key,
        type: getJsBasicType(value),
        desc: obj[key].desc
      })
    } else {
      arr.push({
        parameter: key,
        type: getJsBasicType(value),
        desc: ''
      })
    }
  }
  obj = null
  return arr
}

// 联系客服
export function contactKefu() {
  return window.open('http://q.url.cn/s/yaRhhFm?_type=wpa')
}

let mainUrl = 'localhost'
let apiDomain = 'http://test.openapi.newrank.cn'
if (process.env.NODE_ENV === 'production' && prodtest) {
  mainUrl = 'http://test.main.newrank.cn'
  apiDomain = 'http://test.openapi.newrank.cn'
}
if (process.env.NODE_ENV === 'production' && !prodtest) {
  mainUrl = 'https://newrank.cn'
  // apiDomain = 'https://api.newrank.cn'
  apiDomain = location.origin
}

export { mainUrl, apiDomain }



// WEBPACK FOOTER //
// ./src/assets/js/utils.js